import {login, logout, MFALogin, otpLogin} from '@/api/login'
import {getToken, setToken, getUserInfo, setUserInfo, removeUserInfo} from '@/utils/auth'

const user = {
    state: {
        token: getToken(),
        userInfo: getUserInfo(),
    },
    getters: {},
    mutations: {
        SET_TOKEN: (state, token) => {
            state.token = token
        },
        SET_USERINFO: (state, info) => {
            state.userInfo = info
        },
    },

    actions: {
        // 登录
        otpLogin({commit}, userInfo) {
            return new Promise((resolve, reject) => {
                otpLogin(userInfo).then(response => {
                    console.log(response)
                    let _userInfo = response.data;
                    setToken(_userInfo.token);
                    commit('SET_TOKEN', _userInfo.token);
                    // setUserInfo(_userInfo);
                    // commit('SET_USERINFO', _userInfo);
                    resolve(response)
                }).catch(error => {
                    reject(error)
                })
            })
        },
        // 登录
        Login({commit}, userInfo) {
            return new Promise((resolve, reject) => {
                login(userInfo).then(response => {
                    console.log(response)
                    let _userInfo = response.data;
                    setToken(_userInfo.token);
                    commit('SET_TOKEN', _userInfo.token);
                    // setUserInfo(_userInfo);
                    // commit('SET_USERINFO', _userInfo);
                    resolve(response)
                }).catch(error => {
                    reject(error)
                })
            })
        },
        // 登录
        MFALogin({commit}, userInfo) {
            return new Promise((resolve, reject) => {
                MFALogin(userInfo).then(response => {
                    console.log(response)
                    let _userInfo = response.data;
                    setToken(_userInfo.token);
                    commit('SET_TOKEN', _userInfo.token);
                    // setUserInfo(_userInfo);
                    // commit('SET_USERINFO', _userInfo);
                    resolve(response)
                }).catch(error => {
                    reject(error)
                })
            })
        },
        FedLogOut({commit}) {
            return new Promise((resolve, reject) => {
                logout().then(response => {
                    removeUserInfo();
                    setToken('');
                    commit('SET_TOKEN', '');
                    resolve(response)
                }).catch(error => {
                    reject(error)
                })
            })
        },
    }
}

export default user
